import { event } from '@/api/page-event'

function saveEvent(code, params = {}) {
  event({
    code: code,
    params: params
  }).then(() => {})
}

function dispatchEventStroage() 
{
  const signSetItem = localStorage.setItem
    localStorage.setItem = function (key, val) {
    let setEvent = new Event('setItemEvent')
    setEvent.key = key
    setEvent.newValue = val
    window.dispatchEvent(setEvent)
    signSetItem.apply(this, arguments)
  }
}

function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') != -1
}

// 获取当前滚动条的位置
function getScrollTop() {
  var scrollTop=0
  if(document.documentElement&&document.documentElement.scrollTop){
      scrollTop = document.documentElement.scrollTop
  }else if(document.body){
      scrollTop = document.body.scrollTop
  }
  return scrollTop
}

// 获取当前可视范围的高度
function getClientHeight() {
  var clientHeight = 0
  if(document.body.clientHeight&&document.documentElement.clientHeight){
      clientHeight = Math.min(document.body.clientHeight,document.documentElement.clientHeight)
  }else{
      clientHeight = Math.max(document.body.clientHeight,document.documentElement.clientHeight)
  }
  return clientHeight
}

// 获取文档完整的高度
function getScrollHeight() {
  return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
}

var storageData = {}
window.addEventListener('setItemEvent', function (e) {
  storageData[e.key] = e.newValue
})

function dealCondition(condition, month) {
  if (!condition) return true
  // 处理condition
  var flag = true
  condition.forEach(it => {
    var data = ''
    if (it.conditionCode == 'month') {
      data = month
    } else if (storageData[it.conditionCode]) {
      data = storageData[it.conditionCode]
    } else if (localStorage.getItem(it.conditionCode)) {
      data = localStorage.getItem(it.conditionCode)
    } else {
      data = this.formData[it.conditionCode]
    }
    if (it.condition == 'Between') {
      flag = (data > it.minValue && data < it.maxValue)
    }
    if (it.condition == 'Equal') {
      flag = (data == it.equalValue)
    }
    if (it.condition == 'NotEqual') {
      flag = (data != it.equalValue)
    }
    if (it.condition == 'Include') {
      flag = (it.includeVale.indexOf(data) >= 0)
    }
  })
  return flag
}

export {
  dealCondition,
  getScrollTop,
  getScrollHeight,
  getClientHeight,
  isWeiXin,
  dispatchEventStroage,
  saveEvent
}